import React from 'react';
import { Link } from 'react-router-dom';
import {
  deliveryRouteLabel,
  recipientPrimaryLabel,
  recipientSecondaryLabel,
  recipientTooltip,
  type RecipientLabelInput,
} from '@/utils/recipientDisplay';

type Props = {
  recipient: RecipientLabelInput;
  linkTo?: string;
};

export function RecipientCell({ recipient, linkTo }: Props) {
  const primary = recipientPrimaryLabel(recipient);
  const secondary = recipientSecondaryLabel(recipient);
  const tooltip = recipientTooltip(recipient);

  const primaryEl = linkTo ? (
    <Link to={linkTo} className="table-link recipient-cell__primary" title={tooltip}>
      {primary}
    </Link>
  ) : (
    <span className="recipient-cell__primary">{primary}</span>
  );

  return (
    <div className="recipient-cell" title={tooltip}>
      {primaryEl}
      {secondary && <span className="recipient-cell__secondary">{secondary}</span>}
    </div>
  );
}

export function DeliveryRouteCell({ recipient }: { recipient: RecipientLabelInput }) {
  return (
    <span className="recipient-cell__route" title={recipientTooltip(recipient)}>
      {deliveryRouteLabel(recipient)}
    </span>
  );
}
